module.exports = __webpack_public_path__ + "static/media/doc.1e70a87c.svg";